import type { DeadlineValiditySuggestionDto } from '@prospero/shared';

interface PrefillValiditySuggestionInput {
  documentTypeId: string;
  fetchSuggestion: (documentTypeId: string) => Promise<DeadlineValiditySuggestionDto>;
  /** Rivalutato dopo l'attesa: falso se il tipo è cambiato o l'utente ha già scritto i mesi. */
  canApply: () => boolean;
  applyMonths: (months: number) => void;
}

/** Il suggerimento è un aiuto: se la richiesta fallisce il campo resta vuoto e il form funziona lo stesso. */
export async function prefillValiditySuggestion({
  documentTypeId,
  fetchSuggestion,
  canApply,
  applyMonths,
}: PrefillValiditySuggestionInput): Promise<void> {
  try {
    const suggested = await fetchSuggestion(documentTypeId);
    if (suggested.validityMonths !== null && canApply()) {
      applyMonths(suggested.validityMonths);
    }
  } catch {
    // Nessun messaggio: l'intervallo consigliato resta visibile sotto il campo.
  }
}
